// extracted by mini-css-extract-plugin
export default {"IntagramAuth":"InstagramAuth_IntagramAuth__ZUjJt","TopFridgeImg":"InstagramAuth_TopFridgeImg__3jbKa","Content":"InstagramAuth_Content__SRmDn"};